import {apiClient} from "./api-client";
import type {components} from "./api-types";

// ============================================================================
// Types - re-exported from generated OpenAPI types
// ============================================================================

export type FavoriteCreate = components["schemas"]["FavoriteCreate"];
export type FavoriteResponse = components["schemas"]["FavoriteResponse"];
export type FavoriteListResponse = components["schemas"]["FavoriteListResponse"];
export type FavoriteUpdateOrder = components["schemas"]["FavoriteUpdateOrder"];

// Entity type extracted from FavoriteCreate
export type FavoriteEntityType = FavoriteCreate["entity_type"];

// ============================================================================
// API Functions
// ============================================================================

/**
 * List user's favorites, optionally filtered by entity type
 */
export async function listFavorites(
  entityType?: FavoriteEntityType,
  skip?: number,
  limit?: number
): Promise<FavoriteListResponse> {
  const {data, error} = await apiClient.GET("/api/favorites", {
    params: {
      query: {
        entity_type: entityType,
        skip,
        limit,
      },
    },
  });

  if (error || !data) {
    throw new Error((error as {detail?: string})?.detail || "Failed to fetch favorites");
  }

  return data;
}

/**
 * Create a new favorite
 */
export async function createFavorite(request: FavoriteCreate): Promise<FavoriteResponse> {
  const {data, error} = await apiClient.POST("/api/favorites", {
    body: request,
  });

  if (error || !data) {
    throw new Error((error as {detail?: string})?.detail || "Failed to create favorite");
  }

  return data;
}

/**
 * Reorder favorites by providing an ordered list of favorite IDs
 */
export async function reorderFavorites(favoriteIds: string[]): Promise<void> {
  const {error} = await apiClient.PATCH("/api/favorites/reorder", {
    body: {favorite_ids: favoriteIds},
  });

  if (error) {
    throw new Error((error as {detail?: string})?.detail || "Failed to reorder favorites");
  }
}

/**
 * Delete a favorite
 */
export async function deleteFavorite(favoriteId: string): Promise<void> {
  const {error} = await apiClient.DELETE("/api/favorites/{favorite_id}", {
    params: {
      path: {favorite_id: favoriteId},
    },
  });

  if (error) {
    throw new Error((error as {detail?: string})?.detail || "Failed to delete favorite");
  }
}
